import { useColumns } from '../columns/createUpdateColumns';

/**
 * Returns parameters for showing a mail sender record based on the type.
 *
 * @hook
 * @param {Object} params - The parameters for showing mail sender parameters.
 * @param {string} params.type - The type of mail sender record.
 * @param {Object} params.enums - The enums object.
 * @returns {Object} - Returns an object with parameters.
 */
export const useMailSenderShowParameters = ({ type, enums }) => {
  const { pensionerColumns, ownerColumns, veterinarianAndGroomerColumns } =
    useColumns({ enums, type });

  switch (type) {
    case 'ANOUNCEMENT':
    case 'PENSIONER_WISH':
    case 'PENSIONER_EXPLANATORY_DOCUMENT':
    case 'OTHER_PENSIONER':
      return {
        resourceName: 'pensioners',
        resourceModelName: 'Pensioner',
        columns: pensionerColumns,
        populate: 'pensioners'
      };
    case 'OWNER_WISH':
    case 'OTHER_OWNER':
    case 'OWNER_EXPLANATORY_DOCUMENT':
      return {
        resourceName: 'owners',
        resourceModelName: 'Owner',
        columns: ownerColumns,
        populate: 'owners'
      };
    case 'VETERINARIAN_ADVERT':
      return {
        resourceName: 'veterinarians',
        resourceModelName: 'Veterinarian',
        columns: veterinarianAndGroomerColumns,
        populate: 'veterinarians'
      };
    case 'GROOMER_ADVERT':
      return {
        resourceName: 'groomers',
        resourceModelName: 'Groomer',
        columns: veterinarianAndGroomerColumns,
        populate: 'groomers'
      };
    default:
      return null;
  }
};
